import { datadogRum } from "@datadog/browser-rum";

export const initDatadog = () => {
  if (
    process.env.REACT_APP_DATADOG_APPLICATION_ID &&
    process.env.REACT_APP_DATADOG_CLIENT_TOKEN &&
    process.env.REACT_APP_DATADOG_SITE &&
    process.env.REACT_APP_DATADOG_CLIENT_SERVICE &&
    process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT
  ) {
    return datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
      site: process.env.REACT_APP_DATADOG_SITE,
      env: process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT,
      service: process.env.REACT_APP_DATADOG_CLIENT_SERVICE,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100, // if not included, the default is 100
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
    });
  }
};
